import { OrderProduct } from '@cemex-core/cmx-api';

export const orderItemSorter = (item1: any, item2: any) => {
  const seq1 = item1.itemSeqNumber ? item1.itemSeqNumber : item1.itemSeqNum;
  const seq2 = item2.itemSeqNumber ? item2.itemSeqNumber : item2.itemSeqNum;

  if ((!seq1) || (!seq2)) {
    return -Infinity;
  }

  return Number(seq1) - Number(seq2);
};

export const orderProductSorter = (item1: OrderProduct, item2: OrderProduct) => {
  if (!item1.itemSeqNumber || !item2.itemSeqNumber) {
    return -Infinity;
  }

  return Number(item1.itemSeqNumber) - Number(item2.itemSeqNumber);
};
